import { useEffect }       from 'react';
import { useParams }       from 'react-router-dom';
import { useLocation }     from 'react-router-dom';
import { useNavigate }     from 'react-router-dom';
import { navigationStore } from 'stores/NavigationStore';

export const NavigationSync = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  useEffect(() => {
    navigationStore.setup(navigate);
  }, [navigate]);

  useEffect(() => {
    navigationStore.update(location.pathname, params);
  }, [location.pathname, params]);

  return null;
};